module.exports = __webpack_public_path__ + "img/wxApp1.00ad48a1.png";